<template>
  <pontotel-menu-vertical-gaveta-lateral
    :titulo="tituloGavetaMinhaConta"
    :margem="margem"
    largura="220px"
    @fechar="$emit('fechar')"
  >
    <div class="gaveta">
      <div class="gaveta__secao" v-if="exibirSeletorDePerfil">
        <p class="secao__titulo texto-titulo-p">{{ $t('MenuLateral.gavetaMinhaConta.perfil.titulo') }}</p>
        <div class="secao__opcoes">
          <pontotel-botao-radio
            :titulo="$t('MenuLateral.gavetaMinhaConta.perfil.minhaConta')"
            id="pessoal"
            nome="grupo-opcao-perfil"
            tamanho="M"
            :value="perfilAtual"
            @value="selecionarPerfilDeAcesso"
          />
          <pontotel-botao-radio
            :titulo="$t('MenuLateral.gavetaMinhaConta.perfil.minhaEquipe')"
            id="gestor"
            nome="grupo-opcao-perfil"
            tamanho="M"
            :value="perfilAtual"
            @value="selecionarPerfilDeAcesso"
          />
        </div>
      </div>
      <div class="gaveta__secao">
        <p class="secao__titulo texto-titulo-p">{{ $t('MenuLateral.gavetaMinhaConta.dadosDaConta.titulo') }}</p>
        <div class="secao__dados" v-for="(opcao, index) in dadosDoUsuario" :key="index">
          <span class="texto-paragrafo-pp">{{ opcao.label }}</span>
          <p class="texto-paragrafo-p secao__dados__valor">{{ opcao.valor }}</p>
        </div>
      </div>
      <div class="gaveta__secao">
        <p class="secao__titulo texto-titulo-p">{{ $t('MenuLateral.gavetaMinhaConta.idiomas.titulo') }}</p>
        <div class="secao__opcoes">
          <pontotel-botao-radio
            v-for="idioma in opcoesDeIdiomas"
            :key="idioma.id"
            :titulo="idioma.titulo"
            :icone1="idioma.icone1"
            :id="idioma.id"
            nome="grupo-opcao-idioma"
            tamanho="M"
            :value="idioma.ativo"
            @value="idioma.acao"
          />
        </div>
      </div>
    </div>
  </pontotel-menu-vertical-gaveta-lateral>
</template>

<script>
import { useAcessoStore } from '@next/compartilhados/acesso'
import { pinia } from 'src/pinia'

const iconeBandeiraBrasil =
  '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.91333 4.18555H13.0865V11.8154H2.91333V4.18555Z" fill="#229E45"/>  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.02234 11.1158L12.8149 8.00507L7.99373 4.88477L3.1853 8.01143L8.02234 11.1158Z" fill="#F8E509"/>  <path d="M8.08589 10.0229C9.20432 10.0229 10.111 9.11619 10.111 7.99776C10.111 6.87932 9.20432 5.97266 8.08589 5.97266C6.96746 5.97266 6.06079 6.87932 6.06079 7.99776C6.06079 9.11619 6.96746 10.0229 8.08589 10.0229Z" fill="#2B49A3"/>  <path d="M6.23845 7.17578C6.19002 7.28648 6.15172 7.40135 6.12402 7.51896L9.93327 8.82064C9.98171 8.70994 10.02 8.59507 10.0478 8.47746L6.23845 7.17578Z" fill="white"/></svg>';
const iconeBandeiraEspanha =
  '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">  <path d="M2.91333 4.18555H13.0865V11.8154H2.91333V4.18555Z" fill="#AA151B"/>  <path d="M2.91333 6.0918H13.0865V9.90674H2.91333V6.0918Z" fill="#EFD200"/>  <path d="M7.01742 7.66904V7.48438H6.55542V7.66904H6.65742V8.89571H6.55542V9.08104H7.01742V8.89571H6.91142V7.66904H7.01742Z" fill="#646363"/>  <path d="M4.58944 7.66904V7.48438H4.12744V7.66904H4.23011V8.89571H4.12744V9.08104H4.58944V8.89571H4.48411V7.66904H4.58944Z" fill="#646363"/>  <path d="M6.34681 7.47266H5.57275V8.38797H6.34681V7.47266Z" fill="#EDEDED"/>  <path d="M5.57282 7.47266H4.79785V8.38797H5.57282V7.47266Z" fill="#AA151B"/>  <path d="M5.57324 8.38869L5.57406 9.30358C5.77063 9.30303 5.96453 9.25797 6.14121 9.17179C6.20244 9.14149 6.25408 9.09481 6.29039 9.03694C6.3267 8.97907 6.34625 8.91226 6.34688 8.84395V8.38867L5.57324 8.38869Z" fill="#AA151B"/>  <path d="M4.79785 8.38867V8.84395C4.7985 8.91226 4.81806 8.97906 4.85436 9.03693C4.89066 9.0948 4.94229 9.14148 5.00352 9.17179C5.18138 9.25793 5.37634 9.30298 5.57397 9.30358L5.57321 8.38867H4.79785Z" fill="#FF7300"/>  <path d="M6.19738 6.71153C6.25371 6.73486 6.30186 6.77437 6.33573 6.82507C6.36961 6.87577 6.38769 6.93537 6.38769 6.99634C6.38769 7.05731 6.36961 7.11692 6.33573 7.16761C6.30186 7.21831 6.25371 7.25782 6.19738 7.28115H4.91931C4.86298 7.25782 4.81483 7.21831 4.78096 7.16761C4.74708 7.11692 4.729 7.05731 4.729 6.99634C4.729 6.93537 4.74708 6.87577 4.78096 6.82507C4.81483 6.77437 4.86298 6.73486 4.91931 6.71153C5.12184 6.62733 5.33901 6.58398 5.55835 6.58398C5.77768 6.58398 5.99485 6.62733 6.19738 6.71153Z" fill="#AA151B"/></svg>';
const iconeBandeiraEUA = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.1725 4.25H8.79834V5.09718H13.1725V4.25Z" fill="#BD3D44"/><path d="M13.1725 5.09719H8.79834V5.94437H13.1725V5.09719Z" fill="white"/><path d="M13.1725 5.94436H8.79834V6.79153H13.1725V5.94436Z" fill="#BD3D44"/><path d="M13.1725 6.79314H8.79834V7.64032H13.1725V6.79314Z" fill="white"/><path d="M13.1725 7.6403H8.79834V8.48748H13.1725V7.6403Z" fill="#BD3D44"/><path d="M13.1725 8.48908H8.79834V9.33626H13.1725V8.48908Z" fill="white"/><path d="M13.1725 9.33624H3V10.1834H13.1725V9.33624Z" fill="#BD3D44"/><path d="M8.79832 4.25H3V8.48907H8.79832V4.25Z" fill="#192F5D"/><path d="M13.1725 10.185H3V11.0322H13.1725V10.185Z" fill="white"/><path d="M13.1725 11.0322H3V11.8794H13.1725V11.0322Z" fill="#BD3D44"/></svg>'


export default {
  name: "GavetaMinhaConta",
  props: {
    exibirSeletorDePerfil: {
      type: Boolean,
      required: true
    },
    perfilAtual: {
      type: String,
      required: true
    },
    margem: {
      type: String,
      default: '0 0 0 65px'
    }
  },
  methods: {
    selecionarPerfilDeAcesso(event) {
      const perfil = event.detail[0]

      if (perfil === this.perfilAtual) return

      useAcessoStore(pinia).definirPerfilAtivo(perfil)
      this.$store.commit('atribuirPerfilDeAcessoSelecionadoParaMultiPerfis', perfil)
      this.$router.push({ path: '/' })
      this.$store.dispatch('getUserInfo', true)
    },
    selecionarIdioma(idioma) {
      localStorage.setItem('idioma', idioma);
      this.$i18n.locale = idioma;
      window.location.reload()
    }
  },
  computed: {
    tituloGavetaMinhaConta() {
      if(!this.exibirSeletorDePerfil) {
        return this.$t('MenuLateral.gavetaMinhaConta.perfil.minhaConta')
      }

      const chaveTitulo = this.perfilAtual === 'gestor' ? 'minhaEquipe' : 'minhaConta'
      return this.$t(`MenuLateral.gavetaMinhaConta.perfil.${chaveTitulo}`)
    },
    dadosDoUsuario() {
      const userInfo = this.$store.state.userInfo
      const compEmployeeEhArray = Array.isArray(userInfo.compemployee)

      let opcoes = [{ label: this.$t('MenuLateral.gavetaMinhaConta.dadosDoUsuario.nome'), valor: "" }]

      // Quando compemployee é array, significa que não há empregado associado
      if (compEmployeeEhArray) {
        opcoes[0].valor = userInfo.name
      } else {
        opcoes[0].valor = userInfo.compemployee.name
        opcoes.push({
          label: this.$t('MenuLateral.gavetaMinhaConta.dadosDoUsuario.localDeTrabalho'),
          valor: userInfo.compemployee.company[0].name,
        })
      }

      // Email sempre está disponível independente do tipo de usuário
      opcoes.push({
        label: this.$t('MenuLateral.gavetaMinhaConta.dadosDoUsuario.email'),
        valor: userInfo.email,
      })

      opcoes.push({
        label: this.$t('MenuLateral.gavetaMinhaConta.dadosDoUsuario.permissao'),
        valor: userInfo.roleGroup.name || '-',
      })

      return opcoes
    },
    opcoesDeIdiomas() {
      const IDIOMAS_PADRAO = { 'pt-BR': true, 'es-CO': true, 'en-US': false }

      const dadosInternacionalizacao = this.$store.state.modulosEFuncionalidades.funcionalidades.acesso_seletor_internacionalizacao.value

      let acessoSeletorInternacionalizacao = IDIOMAS_PADRAO

      if (dadosInternacionalizacao) {
        try {
          const dadosParseados = JSON.parse(dadosInternacionalizacao)
          // Valida se o resultado é um objeto válido
          if (dadosParseados && typeof dadosParseados === 'object' && !Array.isArray(dadosParseados)) {
            acessoSeletorInternacionalizacao = dadosParseados
          }
        } catch {
          // Em caso de erro no parse, mantém o fallback IDIOMAS_PADRAO
        }
      }
      const titulos = {
        'pt-BR': this.$t('MenuLateral.gavetaMinhaConta.idiomas.portugues'),
        'es-CO': this.$t('MenuLateral.gavetaMinhaConta.idiomas.espanhol'),
        'en-US': this.$t('MenuLateral.gavetaMinhaConta.idiomas.ingles')
      }
      const icones = {
        'pt-BR': iconeBandeiraBrasil,
        'es-CO': iconeBandeiraEspanha,
        'en-US': iconeBandeiraEUA
      }

      const acoes = {
        'pt-BR': () => this.selecionarIdioma('pt-BR'),
        'es-CO': () => this.selecionarIdioma('es'),
        'en-US': () => this.selecionarIdioma('en-US')
      }

      const id = {
        'pt-BR': 'pt-BR',
        'es-CO': 'es',
        'en-US': 'en-US'
      }

      const idiomasMapeados = Object.keys(acessoSeletorInternacionalizacao).filter(idioma => acessoSeletorInternacionalizacao[idioma]).map(idioma => {
        return {
          id: id[idioma],
          titulo: titulos[idioma],
          icone1: icones[idioma],
          acao: acoes[idioma],
          ativo: this.$i18n.locale
        }
      })
      return idiomasMapeados
    },
  }
};
</script>
<style lang="scss" scoped>
p {
  margin: 0;
}

pontotel-menu-vertical-gaveta-lateral,
.gaveta,
.gaveta p,
.gaveta span,
.gaveta pontotel-botao-radio {
  color: var(--menu-vertical-cor-gaveta-lateral-texto-principal);
}

.gaveta {
  display: flex;
  flex-direction: column;
  gap: 35px;

  &__secao {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
}

.secao {
  &__opcoes {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__dados {
    display: flex;
    flex-direction: column;
    gap: 2px;

    &__valor {
      word-break: break-word;
    }
  }
}
</style>
